import type { RegionMode } from "./regions.js";

export interface CategoryCopy {
  title: string;
  body: string;
}

export interface BannerI18nStrings {
  // Banner
  title: string;
  body: string;
  cookie_policy_link: string; // inline clickable "cookie policy"
  preferences_link: string; // inline clickable "preferences"
  accept_all: string; // "Accept All Cookies"
  decline_all: string; // "Decline All"

  // Pill (shown after decline / partial accept)
  pill_label: string;

  // Preferences modal
  modal_title: string;
  confirm_choices: string;
  always_active: string;

  // Categories — four tabs
  category_necessary: CategoryCopy;
  category_performance: CategoryCopy;
  category_functional: CategoryCopy;
  category_targeting: CategoryCopy;

  // Privacy policy (trailing link; keeps backward compat)
  privacy_link: string;
}

export interface SiteConfig {
  site_id: string;
  domain: string;
  brand_name: string;
  privacy_policy_url: string;
  analytics_enabled: boolean;
  ads_enabled: boolean;
  functional_enabled: boolean;
  banner_version: number;
  policy_version: number;
  region_mode: RegionMode;
  detected_region: string | null;
  accent_color: string;
  i18n: Record<string, BannerI18nStrings>;
}

export interface SiteRow {
  id: string;
  domain: string;
  brand_name: string;
  privacy_policy_url: string;
  analytics_enabled: boolean;
  ads_enabled: boolean;
  functional_enabled: boolean;
  banner_version: number;
  policy_version: number;
  region_mode: RegionMode;
  accent_color: string;
  retention_months: number;
  created_at: string;
}

export const DEFAULT_I18N: Record<string, BannerI18nStrings> = {
  en: {
    title: "Your Privacy, Your Choice",
    body: "We use essential cookies to ensure the site functions properly. We also use optional cookies to improve your experience. You can see our {cookie_policy} for more information and manage your {preferences}.",
    cookie_policy_link: "cookie policy",
    preferences_link: "preferences",
    accept_all: "Accept All Cookies",
    decline_all: "Decline All",

    pill_label: "Cookie settings",

    modal_title: "Cookie Preferences Settings",
    confirm_choices: "Confirm My Choices",
    always_active: "Always Active",

    category_necessary: {
      title: "Strictly Necessary Cookies",
      body: "These cookies are vital for the operation of our website. Without them, certain services you request, such as access to secure areas, may not function properly. These are used to identify and authenticate users, ensure users are connected to the correct website features, and maintain website security.",
    },
    category_performance: {
      title: "Performance Cookies",
      body: "These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. They allow us to improve how the site works.",
    },
    category_functional: {
      title: "Functional Cookies",
      body: "These cookies enable the website to provide enhanced functionality and personalization, such as remembering your preferences. They may be set by us or by third-party providers whose services we've added to our pages.",
    },
    category_targeting: {
      title: "Targeting Cookies",
      body: "These cookies may be set through our site by our advertising partners to build a profile of your interests and show you relevant adverts on other sites. They do not store personal information directly, but are based on uniquely identifying your browser and device.",
    },

    privacy_link: "Privacy policy",
  },
};
